import { colors } from '../../../theme/colors';

export const getAlertBackgroundColor = (variant, theme) => {
  const themeColors = (theme && theme.colors) || colors;
  switch (variant) {
    case 'danger':
      return themeColors.error || colors.error;
    case 'success':
      return themeColors.success || colors.success;
    case 'warning':
      return themeColors.warning || colors.warning;
    case 'info':
    default:
      return themeColors.brandLightBlue || colors.brandLightBlue;
  }
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Alert/utils/alertHelpers.js